import { SET_PAYMENTS } from '../constants/paymentsPayload';

export const setPaymentsPayload = value => dispatch =>
    dispatch({
        type: SET_PAYMENTS,
        payload: value
    });
